import { bffWebApi, TagTypes } from '~/api';
import { FiltersValuesMap } from '~/domain/inventory-list/models/list-filter-types';
import { AssetMapExtendedResponse } from '../models/super-cluster-markers';

const assetMapMarkersAPI = bffWebApi.injectEndpoints({
  endpoints: (build) => ({
    getAssetMap: build.query<AssetMapExtendedResponse, FiltersValuesMap>({
      query: (filters) => ({
        url: `${process.env.ENDPOINT_BFF}/assets/map`,
        params: Object.keys(filters).length > 0 ? filters : undefined,
      }),
      keepUnusedDataFor: 0,
      providesTags: [TagTypes.AssetMap],
    }),
  }),
});

export const { useGetAssetMapQuery, useLazyGetAssetMapQuery } = assetMapMarkersAPI;
export default assetMapMarkersAPI;
